module.exports = __webpack_public_path__ + "static/media/tco-kalkylatorn.292ccc3d.jpg";